"use client";
import OImages from "../OImages";
import CustomButton from "../CustomButton";
import DashedBigCircle from "../icons/DashedBigCircle";
import SinglePartner from "./SinglePartner";
import { useNavigation } from "@/app/hooks/useNavigation"
import { TPartner } from "@/app/types/homePageTypes";
import { useContext } from "react";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { optimizeImageUrl } from "@/app/utils/optimizeImageUrl";
import { isValidImageSrc } from "@/app/utils/isValidImageSrc";

type TPartnersProps = {
	data: TPartner[];
	title: string;
	withBtn?: boolean;
	imgSrc?: string;
	button_text?: string;
	button_url?: string;
	neighborhoodsDetails?: boolean;
	paddingTop?: boolean;
	optimizedImage?: boolean;
	titleClassName?: string;
};

const Partners = ({
	data,
	title,
	withBtn,
	imgSrc,
	button_url,
	button_text,
	neighborhoodsDetails,
	paddingTop,
	optimizedImage,
	titleClassName,
}: TPartnersProps) => {
	const router = useNavigation();
	const {isIpad} = useContext(screenSizeContext)
	
	return (
		<section className={`relative ${neighborhoodsDetails ? "min-h-[105vw]" : "min-h-[130vw]"} ${neighborhoodsDetails ? "my-11 lg:my-[6.25rem]" : "my-[5.5rem]"} lg:min-h-screen ${paddingTop ? "pt-[8.75rem]" : ""}  overflow-hidden`}>
			<div className="section_content_Wrapper || w-[80vw] h-[80vw] lg:w-[80vh] lg:h-[80vh] absolute top-[12.4vw] left-1/2 -translate-x-1/2 lg:top-1/2 lg:-translate-y-1/2">
				<DashedBigCircle />
				<div className="o_container || w-[57.5vw] h-[57.5vw] lg:w-[53vh] lg:h-[53vh] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
					<OImages
						imgsSrc={
							isValidImageSrc(imgSrc)
								? [
										optimizedImage
											? optimizeImageUrl(imgSrc, { width: 828, quality: 80 })
											: imgSrc,
									]
								: []
						}
						svgCustomClass="w-full h-full"
					/>
					<div className="partners_o_content absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col gap-[1.31rem] lg:gap-[2.62rem] items-center text-center">
						<h2
							className={`leading-[0.8] w-[9.74375rem] lg:w-[17.4375rem] ${
								titleClassName ??
								(neighborhoodsDetails
									? "text-bodyL leading-[110%] tracking-[-0.015rem] lg:text-h4 lg:leading-[100%] lg:tracking-[-0.09rem]"
									: "text-h6 lg:text-h3")
							}`}
						>
							{title}
						</h2>
						{!isIpad && withBtn && button_url && (
							<CustomButton
								text={button_text}
								hasIcon
								style="grey"
								action={() => router.push(button_url)}
							/>
						)}
					</div>
				</div>
				<div className="partners_group || w-full h-full lg:w-[75.5vh] lg:h-[75.5vh] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  pointer-events-none">
					{data?.slice(0, 4)?.map((partner, index) => (
						<SinglePartner key={index} image={partner?.imgSrc} degree={90 * index} index={index} optimizedImage={optimizedImage} />
					))}
				</div>
			</div>
			{isIpad && withBtn && button_url && (
				<CustomButton
					text={button_text}
					hasIcon
					style="grey"
					customClass="absolute bottom-0 left-1/2 -translate-x-1/2"
					action={() => router.push(button_url)}
				/>
			)}
		</section>
	);
};
export default Partners;
